/// <reference path="../_references.ts"/>
module App.Appointments {
	import LocationService = App.Helpers.LocationService;

	export class AppointmentService {
		private statusListeners: Array<() => void> = [];

		constructor(
			public $http: ng.IHttpService,
			public Constants: IConstants,
			public LocationService: LocationService,
			public $q: ng.IQService
		){}

		public addStatusListener(listener: () => void): void {
			this.statusListeners.push(listener);
		}

		public removeStatusListener(listener: () => void): void {
			const idx = this.statusListeners.indexOf(listener);
			if (idx >= 0) {
				this.statusListeners.splice(idx, 1);
			}
		}

		public fetch(apptId: number, params?: any): ng.IHttpPromise<Appointment> {
			return this.$http.get(this.Constants.apiUrl + 'appointment/' + apptId, {
				params: params || {},
			});
		}

		public fetchAll(userId: number|'current', params?: any): ng.IHttpPromise<{ today: Appointment[], past: Appointment[] }> {
			return this.$http.get(this.Constants.apiUrl + `user/${userId}/appointments`, {
				params: params || {},
			});
		}

		public create(appointment: Appointment): ng.IHttpPromise<Appointment> {
			return this.$http.post(
				this.Constants.apiUrl + 'appointment/',
				angular.extend({ create_event: 1 }, appointment)
			);
		}

		public updateStatus(apptId: number, status: string): ng.IHttpPromise<Appointment> {
			return this.LocationService.getLocation()
				.then((coords: Coordinates): ng.IHttpPromise<Appointment> => {
					return this.$http.put(this.Constants.apiUrl + 'appointment/' + apptId, {
							appointment_status: status,
							paused: false,
							latitude: coords.latitude,
							longitude: coords.longitude,
							create_event: 1,
						}, {
							params: {
								quiet: 1,
								show_status: 1,
							}
						})
						.then((r: ng.IHttpResponse<Appointment>) => {
							this.statusListeners.forEach(l => l());
							return r;
						});
				});
		}

		public updateEtc(apptId: number, etc: string, duration: number): ng.IHttpPromise<Appointment> {
			return this.LocationService.getLocation().then((coords: Coordinates): ng.IHttpPromise<Appointment> => {
				return this.$http.put(this.Constants.apiUrl + 'appointment/' + apptId, {
					estimated_completion_time: etc,
					scheduled_duration: duration,
					latitude: coords.latitude,
					longitude: coords.longitude,
				}, {
					params: {
						quiet: 1,
						show_etc: 1,
					}
				});
			});
		}

		public sendCustomerText(apptId: number, status: string, additionalText?: string): ng.IHttpPromise<Appointment> {
			return this.$http.post(this.Constants.apiUrl + 'appointment/' + apptId + '/textcustomer', {
				status: status,
				additional_text: additionalText
			});
		}

		public sendCustomerSRText(srId: number, customNumber?: string, status?: string): ng.IHttpPromise<ServiceRequest> {
			return this.$http.post(this.Constants.apiUrl + 'servicerequest/' + srId + '/textcustomer', {
				custom_number: customNumber,
				status: status
			});
		}

		public createSRQuestionnaire(srId: number): ng.IHttpPromise<ServiceRequest> {
			return this.$http.post(this.Constants.apiUrl + 'servicerequest/' + srId + '/questionnaire',{});
		}

		public pauseAppointment(apptId: number): ng.IHttpPromise<void> {
			return this.LocationService.getLocation().then((coords: Coordinates): ng.IHttpPromise<void> => {
				return this.$http.put(this.Constants.apiUrl + 'appointment/' + apptId, {
					paused: true,
					latitude: coords.latitude,
					longitude: coords.longitude
				});
			});
		}

		public pauseAll(userId: number): ng.IHttpPromise<Appointment[]> {
			return this.LocationService.getLocation().then((coords: Coordinates): ng.IHttpPromise<Appointment[]> => {
				return this.$http.put(this.Constants.apiUrl + `user/${userId}/appointments/pause`, {
					latitude: coords.latitude,
					longitude: coords.longitude
				});
			});
		}

		static factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants, LocationService: LocationService, $q: ng.IQService) =>
				new AppointmentService($http, Constants, LocationService, $q);

			instance.$inject = ['$http', 'Constants', 'LocationService', '$q'];

			return instance;
		}
	}
}
